<template>
  <div v-loading="loading">
    <widget-news-list ref="WidgetNews" @refresh="RefreshClick" />
  </div>
</template>

<script>
import { getDouYinNews } from "@/api/news.js";
import WidgetNewsList from "@/components/Widgets/WidgetNewsList.vue";
export default {
  components: {
    WidgetNewsList,
  },
  data() {
    return {
      loading: false,
      Query: {
        skey: "",
        startYmd: "",
        endYmd: "",
        pageIndex: 1,
        pageSize: 20,
      },
      DouYinInfos: [],
    };
  },
  created() {},
  methods: {
    GetDouYinInfos(query) {
      this.loading = true;
      if (query) {
        Object.assign(this.Query, query);
      }
      getDouYinNews(
        this.Query.skey,
        this.Query.startYmd,
        this.Query.endYmd,
        this.Query.pageIndex,
        this.Query.pageSize
      ).then((res) => {
        if (res.code == 0) {
          this.DouYinInfos = res.data.newsList;
          this.$refs.WidgetNews.SetData(this.DouYinInfos, "抖音", "douyin.png", "#394b7a");
        } else {
          this.$message.error(res.data.msg);
        }
        this.loading = false;
      });
    },
    RefreshClick() {
      const getCurrentDate = () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}${month}${day}`;
      };

      const currentDate = getCurrentDate();
      this.Query.startYmd = currentDate;
      this.Query.endYmd = currentDate;

      this.GetDouYinInfos(this.Query);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>